<template>

    <div class="preview_app" :class="['radius' + Global.mockupConfig.radiusRatio, Global.mockupConfig.activeFont, Global.mockupConfig.verticalNav ? 'vert' : '']"
        v-if="inited"
    >

        <transition name="slideup">
            <PreviewHeadbar :scroll="offY" :logo="Global.mockupConfig.pictures.logo" v-show="$route.path !== '/player'"></PreviewHeadbar>
        </transition>

        <transition
            name="fade_preview"
            @after-enter="onAfterEnter"
            @css="false">
            <router-view @scrollUpdate="scrollData"></router-view>
        </transition>

        <div class="b-overlay" :class="{ active : Global.activePreviewOverlay }"></div>
        <PreviewInfoOverlay v-if="Global.activePreviewInfoOverlay"></PreviewInfoOverlay>
        <div class="b-overlay z-mre" :class="{ active : Global.activeSubOverlay }"></div>
        <SubOverlay v-if="Global.activeSubInfoOverlay"></SubOverlay>
        
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'
    import PreviewHeadbar from '../partials/PreviewHeadbar'
    import PreviewInfoOverlay from '../components/PreviewInfoOverlay'
    import SubOverlay from '../components/SubOverlay'

    export default {

        name: 'Preview',

        components: {
            PreviewHeadbar,
            PreviewInfoOverlay,
            SubOverlay
        },
        
        data() {
            return {
                Global,
                inited: false,
                offY: 0
            }
        },

        mounted() {
            window.bc.onmessage = (event) => { 
                this.Global.rows = event.data.rows
                this.Global.plans = event.data.plans
                this.Global.assets = event.data.assets
                this.Global.mockupConfig = event.data.mockupConfig
                this.inited = true
             }
        },

        methods: {

            onAfterEnter() {
                this.offY = 0
            },

            scrollData(val) {
                this.offY = val
            },

            openInfoOverlay() {
                this.Global.tempPreviewClosingOverlay = false
                this.Global.activePreviewOverlay = true
                this.Global.activePreviewInfoOverlay = true
            },

            // openSubOverlay() {
            //     this.Global.tempSubClosingOverlay = false
            //     this.Global.activeSubOverlay = true
            //     this.Global.activeSubInfoOverlay = true
            // },

        },

    }

</script>